import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'


export async function getAllModuleTokenAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/module/token', {})
}

export async function getAllUsersPortfolioTableAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/user/portfolio?parentOrganizationId='+value, {})
}